import { consultar } from 'helpers/api';
import { AppHelper } from 'helpers/AppHelper';

const controller = "usuarios";

export const UsuariosService = {
	login,
	getAll,
	getById,
	create,
	update,
	delete: _delete
};

async function login(params){
	return await consultar(`/${controller}/login.json`, 'put', params);
}

async function getAll(page) {
	var _url = `/${controller}/getAll/${AppHelper.getEmpresaAtivaId()}.json`
	if(page)_url += `?page=${page}`;

	return await consultar(_url);
}

async function getById(id) {
	return await consultar(`/${controller}/${id}.json`);
}

async function create(params) {
	return await consultar(`/${controller}.json`, 'post', params);
}

async function update(id, params) {
	return await consultar(`/${controller}/${id}.json`, 'put', params);
}

// prefixed with underscored because delete is a reserved word in javascript
async function _delete(id) {
	return await consultar(`/${controller}/${id}.json`, 'delete');
}

// Gerado pelo gerador de SERVICES @felipeshow (22:38:08 13/06/2021)
